module.exports = __webpack_public_path__ + "img/img_level_18.a8da6644.png";